"use client";

import { CheckIcon, CopyIcon } from "lucide-react";
import { useState } from "react";

import { useI18n } from "@llmgateway/i18n/react";

export function CopyMarkdownButton({ content }: { content: string }) {
	const { locale } = useI18n();
	const [copied, setCopied] = useState(false);
	const copyLabel = locale === "zh-CN" ? "复制 Markdown" : "Copy Markdown";
	const copiedLabel = locale === "zh-CN" ? "已复制" : "Copied!";

	const handleCopy = async () => {
		await navigator.clipboard.writeText(content);
		setCopied(true);
		setTimeout(() => setCopied(false), 2000);
	};

	return (
		<button
			type="button"
			onClick={handleCopy}
			className="inline-flex items-center gap-2 rounded-md border border-border bg-muted/50 px-3 py-1.5 text-sm text-muted-foreground transition-colors hover:bg-muted hover:text-foreground"
		>
			{copied ? (
				<CheckIcon className="h-4 w-4 text-green-500" />
			) : (
				<CopyIcon className="h-4 w-4" />
			)}
			{copied ? copiedLabel : copyLabel}
		</button>
	);
}
